import { Record } from 'immutable'

export interface IListingProgress {
  readonly hasActiveDate: boolean
  readonly hasAdjoiningPropertyOwners: boolean
  readonly hasBeenPutOnListingServices: boolean
  readonly hasBuildingLayout: boolean
  readonly hasExpirationDate: boolean
  readonly hasFilePositionNo: boolean
  readonly hasFlyer: boolean
  readonly hasOwner: boolean
  readonly hasOwnerThankYouBeenSent: boolean
  readonly hasPhotos: boolean
  readonly hasPhysicalFileBeenCreated: boolean
  readonly hasSentCcimMailbridge: boolean
  readonly hasSentConstantContact: boolean
  readonly hasSentDealmakers: boolean
  readonly hasSentLocalMlsBlast: boolean
  readonly hasSentMarketingToCoC: boolean
  readonly hasSentMarketingToEDC: boolean
  readonly hasSentOwnerListingLink: boolean
  readonly hasSentPersonalEmailToProspects: boolean
  readonly hasSentSignageRequestForm: boolean
  readonly hasServerFileBeenCreated: boolean
  readonly hasSignage: boolean
  readonly hasSocialNetworks: boolean
  readonly hasStdbBusinessList: boolean
  readonly hasSurvey: boolean
  readonly hasTopProspects: boolean
  readonly hasVideoLinks: boolean
  readonly percentageComplete: number
}

const ListingProgressRecord = Record({
  hasActiveDate: false,
  hasAdjoiningPropertyOwners: false,
  hasBeenPutOnListingServices: false,
  hasBuildingLayout: false,
  hasExpirationDate: false,
  hasFilePositionNo: false,
  hasFlyer: false,
  hasOwner: false,
  hasOwnerThankYouBeenSent: false,
  hasPhotos: false,
  hasPhysicalFileBeenCreated: false,
  hasSentCcimMailbridge: false,
  hasSentConstantContact: false,
  hasSentDealmakers: false,
  hasSentLocalMlsBlast: false,
  hasSentMarketingToCoC: false,
  hasSentMarketingToEDC: false,
  hasSentOwnerListingLink: false,
  hasSentPersonalEmailToProspects: false,
  hasSentSignageRequestForm: false,
  hasServerFileBeenCreated: false,
  hasSignage: false,
  hasSocialNetworks: false,
  hasStdbBusinessList: false,
  hasSurvey: false,
  hasTopProspects: false,
  hasVideoLinks: false,
  percentageComplete: 0,
})

export class ListingProgress extends ListingProgressRecord
  implements IListingProgress {
  public static fromJS(initialState?: Partial<IListingProgress>) {
    return new ListingProgress(initialState)
  }

  public readonly hasActiveDate: boolean
  public readonly hasAdjoiningPropertyOwners: boolean
  public readonly hasBeenPutOnListingServices: boolean
  public readonly hasBuildingLayout: boolean
  public readonly hasExpirationDate: boolean
  public readonly hasFilePositionNo: boolean
  public readonly hasFlyer: boolean
  public readonly hasOwner: boolean
  public readonly hasOwnerThankYouBeenSent: boolean
  public readonly hasPhotos: boolean
  public readonly hasPhysicalFileBeenCreated: boolean
  public readonly hasSentCcimMailbridge: boolean
  public readonly hasSentConstantContact: boolean
  public readonly hasSentDealmakers: boolean
  public readonly hasSentLocalMlsBlast: boolean
  public readonly hasSentMarketingToCoC: boolean
  public readonly hasSentMarketingToEDC: boolean
  public readonly hasSentOwnerListingLink: boolean
  public readonly hasSentPersonalEmailToProspects: boolean
  public readonly hasSentSignageRequestForm: boolean
  public readonly hasServerFileBeenCreated: boolean
  public readonly hasSignage: boolean
  public readonly hasSocialNetworks: boolean
  public readonly hasStdbBusinessList: boolean
  public readonly hasSurvey: boolean
  public readonly hasTopProspects: boolean
  public readonly hasVideoLinks: boolean
  public readonly percentageComplete: number

  constructor(props?: Partial<ListingProgress>) {
    props ? super(props) : super()
  }
}
